import { createElement } from 'src/app/core/helpers/dom';
import { humanizeStatus } from 'src/app/project/modules/points/statuses';
import { getTableStatusSrc } from '../../../../../shared/status-to-image';
import { TColumn } from '../../columns/column.model';
import { GET_TABLE } from '../../table.ui.store';
import { createCellElement } from '../createCellElement';

export function createStatusElement(index: number, column: TColumn): HTMLElement {
  const table = GET_TABLE();

  let imageElementWrapper: HTMLElement;

  if (!table.getPoints()[index].status) {
    imageElementWrapper = createElement('div');
  } else {
    imageElementWrapper = createElement('img', {
      attrs: {
        class: 'statusIcon statusIcon--gray statusIcon--table',
        title: humanizeStatus(table.getPoints()[index].status),
        src: getTableStatusSrc(table.getPoints()[index].status),
      },
    });
  }

  return createCellElement({
    index: column.index,
    width: `${column.width}px`,
    center: true,
    child: imageElementWrapper,
  });
}
